<template>
	<div class="machine-type">
		<div class="el-search vue-top-padding">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['machine:type:insert']"
					icon="el-icon-plus"
					@click="addMachineType"
					style="margin: 0"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="machineType"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height">
					<el-form-item prop="name" style="margin: 0 10px 0 0">
						<el-input
							v-model="search.name"
							:placeholder="$t('machineType.name')"></el-input>
					</el-form-item>
					<el-form-item prop="name" style="margin: 0 10px 0 0">
						<el-input
							v-model="search.aisleNum"
							:placeholder="$t('machineType.aisleNum')"></el-input>
					</el-form-item>
					<el-form-item style="margin: 0">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('machineType')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="machine-Type vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="machineTypeList"
				@selection-change="handleSelectionChange"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					type="selection"
					width="40"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="name"
					:show-overflow-tooltip="true"
					:label="$t('machineType.name')"
					:align="'center'"
					width="250px"></el-table-column>
				<el-table-column
					prop="aisleNum"
					:show-overflow-tooltip="true"
					:label="$t('machineType.aisleNum')"
					:align="'center'"
					width="180px"></el-table-column>
				<el-table-column
					prop="rentPrice"
					:show-overflow-tooltip="true"
					:label="$t('machineType.xfje1')"
					:align="'center'"
					width="160px"></el-table-column>
				<el-table-column
					prop="notes"
					:label="$t('machineType.notes')"></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('machineType.createTime')"
					:align="'center'"
					width="160px"></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:align="'center'"
					:width="$i18n.locale == 'zh_CN' ? 85 : 100">
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['machine:type:update']"
							@click="editMachineType(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="machineTypeList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"></el-pagination>
		</div>
		<!-- add or edit machineType dialog -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="machineType.id ? $t('machineType.edit') : $t('machineType.add')"
			:visible.sync="dialogMachineType"
			width="35%"
			top="9vh"
			@closed="closeDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="machineType"
					label-width="80px"
					:model="machineType">
					<el-form-item
						:label="$t('machineType.name')"
						prop="name"
						:error="error.name">
						<el-input
							v-model="machineType.name"
							:placeholder="$t('machineType.pName')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item :label="$t('machineType.aisleNum')" prop="aisleNum">
						<el-input
							v-model="machineType.aisleNum"
							:disabled="!!machineType.id"
							:placeholder="$t('machineType.pLineNum')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item :label="$t('machineType.xfje')" prop="rentPrice">
						<el-input
							v-model="machineType.rentPrice"
							:placeholder="$t('machineType.pxfje')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item :label="$t('machineType.remarksInfo')">
						<el-input
							type="textarea"
							:rows="4"
							v-model="machineType.notes"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('machineType')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "MachineType",
	data() {
		return {
			search: {
				name: "",
				aisleNum: "",
			},
			machineType: {
				id: "",
				name: "",
				aisleNum: "",
				rentPrice: "",
				notes: "",
			},
			error: {
				name: "",
			},
			multipleSelection: [],
			loading: false,
			machineTypeList: [],
			dialogMachineType: false,
			labelPosition: "top",
			rules: {
				name: [
					{
						required: true,
						message: this.$t("machineType.pName"),
						trigger: "blur",
					},
				],
				aisleNum: [
					{
						required: true,
						message: this.$t("machineType.pLineNum"),
						trigger: "blur",
					},
				],
				rentPrice: [
					{
						required: true,
						message: this.$t("machineType.pxfje"),
						trigger: "blur",
					},
				],
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			loadingForm: false,
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		addMachineType() {
			this.dialogMachineType = true;
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.MachineType.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.machineTypeList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		closeDialog() {
			this.dialogMachineType = false;
			this.clearValidate("machineType");
			this.$toolUtil.clearForm(this.machineType);
		},
		editMachineType(row) {
			this.dialogMachineType = true;
			Object.keys(this.machineType).forEach(key => {
				this.machineType[key] = row[key];
			});
			this.machineType.id = row.id;
		},
		onSubmit() {
			this.currentChange();
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.currentChange();
		},
		cancel() {
			this.dialogMachineType = false;
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.MachineType.insert;
					let method = this.$method.post;
					if (this.machineType.id) {
						url = this.$url.MachineType.update;
						method = this.$method.put;
					}
					this.$api
						.request(url, method, this.machineType)
						.then(res => {
							if (res.code === 0) {
								this.dialogMachineType = false;
								this.$notify({
									title: this.$t("common.tip"),
									message:
										(this.machineType.id
											? this.$t("machineType.up")
											: this.$t("machineType.save")) +
										this.$t("machineType.machineTypeS"),
									type: "success",
								});
								this.currentChange(this.page.pageIndex);
							} else {
								this.$toolUtil.msg(res, this.error);
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
	},
};
</script>

<style>
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
